export default __webpack_public_path__ + "static/media/4.cdd71014.png";